import { Button } from '@/components/ui/button';

interface SenderLoadErrorProps {
	onRetry: () => void;
	message?: string;
}

export default function SenderLoadError({ onRetry, message = 'Не удалось загрузить' }: SenderLoadErrorProps) {
	return (
		<div className='flex flex-col gap-3 py-4'>
			<p className='text-[15px]'>{message}</p>
			<Button type='button' variant='outline' className='min-h-11 w-fit' onClick={onRetry}>
				Повторить
			</Button>
		</div>
	);
}
